module.exports = __webpack_public_path__ + "img/Service.c4992cfe.png";